import api from "./api";

export const getBatchAnalytics = () => {
  return api.get("/api/analytics/batch/overview");
};